import { render, staticRenderFns } from "./Faturamento.vue?vue&type=template&id=5b430e7f&"
import script from "./Faturamento.vue?vue&type=script&lang=js&"
export * from "./Faturamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports